import React from "react";
import RepairandServiceDetails from "./RepairandServiceDetails";
import Contact from "../../common/Contact/Contact";
import FooterThree from "../../common/Footer/FooterThree";
import Menu from "../../common/Menu/Menu";
import RepairandServiceBanner from "./RepairandServiceBanner";

const RepairandService = () => {
    return (
        <>
      <Menu header_style_2={true} />
      <RepairandServiceBanner />
      <RepairandServiceDetails />
      <Contact />
      <FooterThree />
    </>
    )
}
export default RepairandService;